<template>
  <v-menu
    offset-y
  >
    <v-btn
      slot="activator"
      flat
      icon
      small
      color="info lighten-2"
      class="ma-0"
    >
      <v-icon small>
        help
      </v-icon>
    </v-btn>
    <div>
      <v-card class="light-blue lighten-5">
        <v-card-text style="width: 550px">
          <div>
            海快體積限制：
            <br>
            單件包裹限制長寬高180cm*180cm*長(不限)，三邊長度其中兩邊不得超過180cm (例如：110*90*500 可以，190*120*200 不可以)
            <br>
            <br>
            海快重量限制：
            <br>
            單件不能超過70kg
            <br>
            <br>
            離島地區每筆訂單加收250元派件費，推薦使用平潭倉，巧巧郎額外補貼100元。
            <br>
            <br>
            <div>
              禁止運送項目：
              食品、農產品、乾燥花、地板、瓷磚、電話卡(網卡)、醫藥用品、酒、毒品、槍支、易燃易爆物、電子煙相關產品...等等
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </v-menu>
</template>

<script>
export default {

}
</script>

<style>

</style>
